const form = {
  formId: "new-user-form",
  formField: {
    bankName: {
      name: "bankName",
      label: "1. Tên ngân hàng thương mại:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên ngân hàng thương mại",
    },
    taxId: {
      name: "taxId",
      label: "2. Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "3. Địa chỉ:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    city: {
      name: "city",
      label: "Tỉnh/Thành phố",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh/thành phố",
    },
    district: {
      name: "district",
      label: "Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận/huyện",
    },
    ward: {
      name: "ward",
      label: "Phường/xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập phường/xã",
    },
    //
    sentDate: {
      name: "sentDate",
      label: "4. Ngày gửi:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn ngày gửi",
    },
    sendingPeriod: {
      name: "sendingPeriod",
      label: "5. Kỳ gửi:",
      type: "text",
    },
    sendingTimes: {
      name: "sendingTimes",
      label: "6. Lần gửi:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập lần thay thế",
    },
    bankId: {
      name: "bankId",
      label: "7. Mã ngân hàng:",
      type: "text",
    },
    signer: {
      name: "signer",
      label: "Người ký:",
      type: "text",
      errorMsg: "Vui lòng nhập tên người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký:",
      type: "number",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
